import React from "react";
import PropTypes from "prop-types";
import nanoid from "ati-utils/nanoid";

import styles from "./PopupLink.scss";

const PopupLink = React.forwardRef(
  (
    {
      className = "",
      params = "top=150,left=200,width=1000,height=800,resizable=1,scrollbars=1,menubar=0",
      disabled,
      href,
      onPopupOpen,
      children,
      name,
      onClick,
    },
    ref
  ) => {
    const openPopup = (event) => {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }

      const popupId = nanoid();

      if (!disabled) {
        window.open(href, popupId, params);
        if (onPopupOpen) {
          onPopupOpen(popupId, href);
        }
      }
    };

    return (
      <a
        ref={ref}
        className={[styles["no-link-decor"], className].join(" ")}
        href={href}
        onClick={openPopup}
        data-name={name}
      >
        {children}
      </a>
    );
  }
);

PopupLink.propTypes = {
  href: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    .isRequired,
  children: PropTypes.node.isRequired,
  onPopupOpen: PropTypes.func,
  className: PropTypes.string,
  params: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PopupLink;
